import { IMucThuTamThuActionTypes } from "../../action-types/muc-thu/IMucThuTamThuActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IMucThuTamThuReducer } from "../../reducer-model/muc-thu/IMucThuTamThuReducer";

const iniState: IMucThuTamThuReducer = {
  status: eReducerStatusBase.is_not_initialization,
  mucThuTamThuSinhViens: [],
  soTienConLaiSinhViens: [],
};
export const mucThuTamThuReducer = (
  state: IMucThuTamThuReducer = iniState,
  action: IMucThuTamThuActionTypes
): IMucThuTamThuReducer => {
  switch (action.type) {
    case "MUC_THU_TAM_THU_LOAD_MUC_THU_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MUC_THU_TAM_THU_LOAD_MUC_THU_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucThuTamThuSinhViens: [
          ...state.mucThuTamThuSinhViens.filter(
            (g) => g.id_sv !== action.payload.id_sv
          ),
          {
            id_sv: action.payload.id_sv,
            data: action.payload.data,
          },
        ],
      };
    case "MUC_THU_TAM_THU_LOAD_MUC_THU_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_TAM_THU_LOAD_SO_TIEN_CON_LAI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MUC_THU_TAM_THU_LOAD_SO_TIEN_CON_LAI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        soTienConLaiSinhViens: [
          ...state.soTienConLaiSinhViens.filter(
            (g) => g.id_sv !== action.payload.id_sv
          ),
          {
            id_sv: action.payload.id_sv,
            data: action.payload.data,
          },
        ],
      };
    case "MUC_THU_TAM_THU_LOAD_SO_TIEN_CON_LAI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
